// @NOTE: assumes jQuery is included by WP
const $ = jQuery

class news {
  constructor () {
    this.$jsCategoryDropdownOption = $('.js-category-dropdown .option')
    this.$jsLoadMoreButton         = $('.js-load-more-btn')
    this.$newsContainer            = $('#news-container')
    this.$newsListing              = $('.news-listing')
    this.maxNumPages               = this.$jsLoadMoreButton.attr('data-max-pages')
    this.currentPage               = 1;
    this.postsPerPage              = 10;
    this.category                  = ''
    this.isLoadmore                = false

    if(this.currentPage == this.maxNumPages) {
      this.$jsLoadMoreButton.hide()
    } else {
      this.$jsLoadMoreButton.show()
    }
    this.$categoryDropdown = $('.js-category-dropdown');
    this.$selectBtn = $('.selectBtn');

    this.$categoryDropdown.removeClass('toggle');

    this.$selectBtn.on('click', () => {
      this.$categoryDropdown.toggleClass('toggle');
    });

    this.$jsCategoryDropdownOption.on('click', (event) => {
      this.$jsCategoryDropdownOption.removeClass('active');
      $(event.currentTarget).addClass('active');
      const selectedText = $(event.currentTarget).text();
      this.$selectBtn.text(selectedText);
      this.$categoryDropdown.removeClass('toggle');
      this.isLoadmore   = false
      this.currentPage  = 1
      this.category     = $(event.currentTarget).attr('data-type');
      this.loadPosts(this.isLoadmore, this.category, this.currentPage);
    })

    this.$jsLoadMoreButton.on('click', (event) => {
      this.isLoadmore  = true
      this.currentPage++;
      this.loadPosts(this.isLoadmore, this.category, this.currentPage);
    });
  }

  loadPosts (isLoadmore, category, currentPage) {
    this.$newsListing.addClass('loading')
    this.$jsLoadMoreButton.show();
    console.log(currentPage)
    $.ajax({
      url: window.ajaxUrl,
      type: 'post',
      data: {
        action: 'filter_posts_by_category_slug',
        category: category,
        page: currentPage,
        posts_per_page: this.postsPerPage
      },
      success: (response) => {
          if (response) {
            if(isLoadmore) {
              this.$newsContainer.append(response.html);
            } else {
              this.$newsContainer.html(response.html);
            }
            if (currentPage == response.max_pages) {
              this.$jsLoadMoreButton.hide();
            }

          } else {
            this.$newsListing.removeClass('loading')
          }
      },
      complete: () => {
        this.$newsListing.removeClass('loading')
      }
  });
  }
}

export default news


// WEBPACK FOOTER //
// ./src/js/custom/news/news.js